<template>
  <router-view />
</template>

<script>
export default {
  name: 'MedicaidWrapper',
  data: () => ({
    page: {
      title: 'Medicaid',
      icon: 'fas fa-file-certificate',
      routes: ['Medicaid'],
    },
  }),
  provide() {
    return {
      page: this.page,
    };
  },
};
</script>
